import { css } from 'styled-components';
export const helveticaConfig = {
    ['57-condensed']: {
        family: 'Helvetica Neue LT W05_57 Cond',
        weight: 400,
        style: 'normal',
    },
    ['77-condensed-bold']: {
        family: 'Helvetica Neue LT W05_77 Bd Cn',
        weight: 700,
        style: 'normal',
    },
    ['87-condensed-heavy']: {
        family: 'Helvetica Neue LT W05_87 Hv Cn',
        weight: 900,
        style: 'normal',
    },
};
// TODO: I can't for the life of me get the return type of this function to play nicely with styled components when importing, leaving this for now
function font(family, weight, style) {
    return css `
    font-family: ${family};
    font-weight: ${weight};
    font-style: ${style};
  `;
}
export default {
    helvetica: {
        ['57-condensed']: font(helveticaConfig['57-condensed'].family, helveticaConfig['57-condensed'].weight, helveticaConfig['57-condensed'].style),
        ['77-condensed-bold']: font(helveticaConfig['77-condensed-bold'].family, helveticaConfig['77-condensed-bold'].weight, helveticaConfig['77-condensed-bold'].style),
        ['87-condensed-heavy']: font(helveticaConfig['87-condensed-heavy'].family, helveticaConfig['87-condensed-heavy'].weight, helveticaConfig['87-condensed-heavy'].style),
    },
    ls: (value) => {
        return `calc(${value / 1000} * 1em)`;
    },
};
